import { styled, TextField } from '@mui/material';

import { getHoverTouchStyles } from '@mopla/utils';

export const MplInput = styled(TextField)(({ theme, disabled }) => {
	const color = disabled
		? theme.palette.neutral[80]
		: theme.palette.primary.main;

	return {
		color,

		'& *': {
			color,
		},

		'.MuiOutlinedInput-root': {
			borderRadius: 8,
		},

		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				borderColor: color,
			},

			...getHoverTouchStyles({ borderColor: color }),
		},
	};
});
